import { render, staticRenderFns } from "./AlarmDetail.vue?vue&type=template&id=80b0dd00&"
import script from "./AlarmDetail.vue?vue&type=script&lang=js&"
export * from "./AlarmDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlarmDetail.vue?vue&type=style&index=0&id=80b0dd00&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports